import { useEffect, useRef } from 'react'
import { type LocalMediaFailure, useLocalMediaFailure } from '@/entities/call'
import { toast } from '@/shared/ui/toast'

// Что человек может сделать с отказом устройства — по причине, а не «ошибка».
const CAUSE: Record<LocalMediaFailure['reason'], string> = {
  denied: 'разрешите доступ в настройках браузера',
  busy: 'устройство занято другим приложением',
  missing: 'устройство не найдено',
  unknown: 'попробуйте включить его в панели звонка',
}

export function mediaFailureMessage(failure: LocalMediaFailure): string {
  const device = failure.kind === 'mic' ? 'микрофону' : 'камере'
  return `Нет доступа к ${device}: ${CAUSE[failure.reason]}`
}

// Вход состоялся, но устройство не поднялось: раньше это рвало соединение и
// уводило в петлю переподключения, теперь звонок идёт — и человек узнаёт, чего
// в нём не хватает и почему.
export function useLocalMediaFailureToast(): void {
  const failure = useLocalMediaFailure()
  const reported = useRef<string | null>(null)

  useEffect(() => {
    if (!failure) {
      // Устройство поднялось — следующий отказ снова достоин тоста.
      reported.current = null
      return
    }
    const key = `${failure.kind}:${failure.reason}`
    if (reported.current === key) return
    reported.current = key
    toast.error(mediaFailureMessage(failure))
  }, [failure])
}
